import { render, staticRenderFns } from "./Administrations.vue?vue&type=template&id=0320c3aa&"
import script from "./Administrations.vue?vue&type=script&lang=js&"
export * from "./Administrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports